import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { RCCHookToast, RCCServicesApi } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import { useConfirmModal } from "src/context/ConfirmModal/context";
import ModalAccessKey from "src/components/ModalAccessKey";
import IRefModalAccessKey from "src/components/ModalAccessKey/interface";
import { IComponentModalExternalAccessKeys, IEftbs004, IRefModalExternalAccessKeys } from "./interface";


const Modals: React.ForwardRefRenderFunction<IRefModalExternalAccessKeys, IComponentModalExternalAccessKeys> = ({
	paginationRef
}, ref) => {

	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();
	const { confirm } = useConfirmModal();

	const modalAccessKey = useRef<IRefModalAccessKey>(null);

	const actionButtonDelete = (row: IEftbs004) => {
		confirm(
			translate("Finalizar sessão"),
			`${translate("Deseja realmente finalizar a sessão")}: ${row.efs004Key} ?`,
			async () => {

				await RCCServicesApi.putRequest({
					method: "AccessKey/EndSession",
					urlParameters: {
						id: row.efs004Id
					}
				});

				addToast({
					color: "green",
					description: translate("Sessão finalizada com sucesso"),
					title: translate("Sucesso")
				});
				
				paginationRef.current?.reload();
			},
			(err) => {
				standardErrorMessages(err, translate("Erro ao finalizar sessão"), addToast);
			},
			true
		);
	};
	
	const actionButtonAdd = () => {
		confirm(
			translate("Gerar chave de acesso externo"),
			`${translate("Deseja gerar uma chave de acesso")} ?`,
			async () => {

				const { data } = await RCCServicesApi.postRequest({
					method: "AccessKey/Insert"
				});

				modalAccessKey.current?.openModalOnlyShowAccessKey(data);
				paginationRef.current?.reload();
			},
			(err) => {
				standardErrorMessages(err, translate("Erro ao gerar chave de acesso"), addToast);
			},
			false
		);
	};

	useImperativeHandle(ref, () => ({
		actionButtonAdd,
		actionButtonDelete
	}));
    
	return (
		<>	
			<ModalAccessKey 
				ref={modalAccessKey}
			/>	
		</>
	);
};

export default forwardRef(Modals);
